<template>
  <div>
    <input
      ref="input"
      v-model="searchTerm"
      v-bind="$attrs"
      :class="{'is-invalid': isInvalid}"
      class="form-control"
      type="search"
      autocomplete="nope"
      @focus="isFocused = true"
      @blur="handleBlur"
      v-on="$listeners"
    >
    <typeahead-list
      v-show="isFocused && items.length > 0"
      :items="formattedItems"
      :search-term="searchTerm"
      class="typeahead-list"
      @hit="handleHit"
    >
      <slot />
    </typeahead-list>
  </div>
</template>

<script>
import TypeaheadList from './TypeaheadList'
import debounce from 'lodash.debounce'
export default {
  name: 'Typeahead',
  components: {
    TypeaheadList
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Object, Number],
      default: ''
    },
    inputFormatter: {
      type: Function,
      default: (value) => value
    },
    resultFormatter: {
      type: Function,
      default: (value) => value
    },
    query: {
      type: Function,
      default: (value) => value
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    items: [],
    isFocused: false,
    pending: false
  }),
  computed: {
    searchTerm: {
      get () {
        if (typeof this.value === 'string') {
          return this.value
        } else if (typeof this.value === 'number') {
          return this.value.toString()
        } else {
          return this.inputFormatter(this.value)
        }
      },
      set (input) {
        if (typeof input === 'string') {
          this.$emit('input', input)
        } else if (typeof input === 'number') {
          this.$emit('input', input.toString())
        } else {
          this.$emit('input', this.inputFormatter(input))
        }
      }
    },
    formattedItems () {
      return this.items.map((item, index) => {
        return {
          index,
          data: item,
          input: this.inputFormatter(item),
          result: this.resultFormatter(item)
        }
      })
    }
  },
  watch: {
    searchTerm: {
      handler: 'search'
    }
  },
  methods: {
    debouncedSearch: debounce(async function (term) {
      if (term) {
        const request = await this.query(term)
        this.items = request.data
        this.pending = false
      }
    }, 500),
    search (term) {
      this.pending = true
      this.items = []
      this.debouncedSearch(term)
    },
    handleHit (item) {
      if (typeof this.value !== 'undefined') {
        this.$emit('input', item.input)
      }
      this.searchTerm = item.input
      this.$emit('hit', item.data)
      this.$refs.input.blur()
      this.isFocused = false
    },
    handleBlur (evt) {
      const tgt = evt.relatedTarget
      if (tgt && tgt.classList.contains('vbst-item')) {
        return
      }
      this.isFocused = false
    }
  }
}
</script>

<style scoped>
  .typeahead-list {
    padding-top: 5px;
    position: absolute;
    max-height: 350px;
    overflow-y: auto;
    z-index: 999;
  }
</style>
